import React from 'react';
import Avatar from "../../components/common/Avatar";
import Chip from "../../components/common/Chip";

const RoleManagementWorklistRow = ({ item, rowIndex, menuRights, handleView, handleEdit, handleDelete }) => {

    const canOpenActions = (menuRights?.canView === true || menuRights?.canEdit === true || menuRights?.canDelete === true) && item?.systemDefault !== true;
    return (
        <div className={`card quote-project-row ${rowIndex % 2 === 0 ? 'row-even' : 'row-odd'}`}>
            <div className="card-body">
                <div className="quote-project-grid">
                    <div
                        className="project-cell"
                        onClick={
                            menuRights?.canEdit === true && item?.systemDefault !== true
                                ? () => handleEdit(item)
                                : menuRights?.canView === true
                                    ? () => handleView(item)
                                    : undefined
                        }
                    >
                        <Avatar preName={item?.roleName} />
                        <div className="project-copy">
                            <h4>{item?.roleName}</h4>
                        </div>
                        {!item?.isActive && <Chip status={item?.status} />}
                    </div>

                    <div>{item?.onlyForDistributor === true ? "Yes" : "No"}</div>

                    <div className="open-cell">

                        {canOpenActions && (
                            <div className="dropdown dropleft text-align">
                                <i className="fas fa-ellipsis-v" id={`dropdownMenuButton-${rowIndex}`}
                                    data-toggle="dropdown"
                                    aria-haspopup="false"
                                    aria-expanded="false"></i>
                                <div className="dropdown-menu p-0" aria-labelledby={`dropdownMenuButton-${rowIndex}`}>
                                    <ul>
                                        {menuRights?.canEdit === true && (
                                            <li onClick={() => handleEdit(item)}>
                                                <span><i className="far fa-edit"></i> Edit</span>
                                            </li>
                                        )}
                                        {menuRights?.canDelete === true && (
                                            <li onClick={() => handleDelete(item)}>
                                                <span><i className="far fa-trash-alt mr-1"></i> Delete</span>
                                            </li>
                                        )}
                                        {menuRights?.canView === true && (
                                            <li onClick={() => handleView(item)}>
                                                <span><i className="far fa-eye mr-1"></i> View</span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        )}

                        {menuRights?.canView === true && (
                            <button
                                type="button"
                                className="row-arrow-btn"
                                onClick={() => handleView(item)}
                                aria-label="View role">
                                <i className="fas fa-chevron-right"></i>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(RoleManagementWorklistRow)